/**
 * @fileoverview CSS module for styling customer satisfaction question components
 * Used for rendering customer satisfaction questions with radio buttons and navigation
 *
 * @example
 * // Usage in component:
 * import styles from './CustomerSatisfactionQuestion.module.css';
 *
 * <div className={styles.container}>
 *   <div className={styles.choice_container}>
 *     <label className={styles.radio_container}>
 *       <input type="radio" className={styles.radio_input} />
 *       Choice option
 *     </label>
 *   </div>
 * </div>
 */

.radio_input {
    display: none;
}

.button:focus,
.button:hover {
    background-color: var(--indigo100);
}

.button {
    display: flex;
    justify-content: center;
    padding: 12px;
}

.selected {
    border: 1px solid var(--neutural900) !important;
    border-radius: var(--radius-md) !important;
    outline: none !important;
    box-shadow: 0px 0px 0px 6px var(--indigo300);
    z-index: 1;
}

.choice_container {
    gap: 16px;
}

.label_container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    color: var(--neutural500);
}

.high_label {
    text-align: end;
}

@media only screen and (min-width: 768px) {
    .high_label {
        text-align: left;
    }

    .button {
        padding: 16px 24px;
    }
}
